import React from "react";
const Breadcrumb = ({ title }) => {
  return (
    <div className='d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24'>
      <h5 className='fw-semibold mb-0'>{title}</h5>
    </div>
  );
};

export default Breadcrumb;
